import * as S from '@effect/schema/Schema'
import MarketingListSchema from 'features/ListBuilder/infra/repo/schema/MarketingListSchema'

export const GETListsByPageSchema = S.Struct({
  count: S.Number,
  items: S.Array(MarketingListSchema),
})

export type GETListsByPageSchema = S.Schema.Type<typeof GETListsByPageSchema>
